(function () {
    fabric.util.object.extend(fabric.Canvas.prototype, {
        editMode: false,
        _alignObjecToCanvas: function (activeObject, align) {
            const activeObjectBound = activeObject?.getBoundingRect(true);
            const isActiveSelection = activeObject.isType('activeSelection');
            const canvasWidth = (this.getArtworkWidth() / this.getZoom()) * this.getEffectiveZoom();
            const canvasHeight = (this.getArtworkHeight() / this.getZoom()) * this.getEffectiveZoom();
            const activeWidth = isActiveSelection ? activeObjectBound.width : activeObject.width;
            const activeHeight = isActiveSelection ? activeObjectBound.height : activeObject.height;
            switch (align) {
                case 'left':
                    activeObject.set(
                        'left',
                        isActiveSelection ? 0 : activeObject.originY === 'center' ? activeWidth / 2 : 0
                    );
                    break;
                case 'right':
                    activeObject.set(
                        'left',
                        isActiveSelection
                            ? canvasWidth - activeWidth
                            : activeObject.originY === 'center'
                            ? canvasWidth - activeWidth / 2
                            : canvasWidth - activeWidth
                    );
                    break;
                case 'top':
                    activeObject.set(
                        'top',
                        isActiveSelection ? 0 : activeObject.originY === 'center' ? activeHeight / 2 : 0
                    );
                    break;
                case 'bottom':
                    activeObject.set(
                        'top',
                        isActiveSelection
                            ? canvasHeight - activeHeight
                            : activeObject.originY === 'center'
                            ? canvasHeight - activeHeight / 2
                            : canvasHeight - activeHeight
                    );
                    break;
                case 'middle': {
                    const leftView = canvasWidth / 2;
                    activeObject.set(
                        'left',
                        isActiveSelection
                            ? leftView - activeWidth / 2
                            : activeObject.originY === 'center'
                            ? leftView
                            : leftView - activeWidth / 2
                    );
                    break;
                }
                case 'center': {
                    const topView = canvasHeight / 2;
                    activeObject.set(
                        'top',
                        isActiveSelection
                            ? topView - activeHeight / 2
                            : activeObject.originY === 'center'
                            ? topView
                            : topView - activeHeight / 2
                    );
                    break;
                }
                case 'fit-width': {
                    if (isActiveSelection) {
                        activeObject.scale(activeObject.scaleX * (canvasWidth / activeWidth));
                        this._alignObjecToCanvas(activeObject, 'center');
                        this._alignObjecToCanvas(activeObject, 'middle');
                        break;
                    } else if (activeObject.horizontalDiameter) {
                        activeObject.set('horizontalDiameter', canvasWidth - (activeObject.width - activeObject.horizontalDiameter));
                    } else if (activeObject.setWidth) {
                        activeObject.setWidth(canvasWidth);
                    } else {
                        activeObject.set('width', canvasWidth);
                    }
                    if (this.editMode && !isActiveSelection) {
                        activeObject.editedSize = true;
                    }

                    this._alignObjecToCanvas(activeObject, 'middle');
                    break;
                }
                case 'fit-height': {
                    if (isActiveSelection) {
                        activeObject.scale(activeObject.scaleY * (canvasHeight / activeHeight));
                        this._alignObjecToCanvas(activeObject, 'center');
                        this._alignObjecToCanvas(activeObject, 'middle');
                        break;
                    } else if (activeObject.verticalDiameter) {
                        activeObject.set('verticalDiameter', canvasHeight - (activeObject.height - activeObject.verticalDiameter));
                    } else if (activeObject.setHeight) {
                        activeObject.setHeight(canvasHeight);
                    } else {
                        activeObject.set('height', canvasHeight);
                    }
                    if (this.editMode && !isActiveSelection) {
                        activeObject.editedSize = true;
                    }

                    this._alignObjecToCanvas(activeObject, 'center');
                    break;
                }
                case 'fit': {
                    if (isActiveSelection) {
                        break;
                    } else {
                        if (activeObject.horizontalDiameter || activeObject.verticalDiameter) {
                            activeObject.set({
                                horizontalDiameter:
                                    canvasWidth - (activeObject.width - activeObject.horizontalDiameter),
                                verticalDiameter: canvasHeight - (activeObject.height - activeObject.verticalDiameter)
                            });
                            if (this.editMode) {
                                activeObject.editedSize = true;
                            }
                        } else if (activeObject.setWidth || activeObject.setHeight) {
                            activeObject.setWidth(canvasWidth);
                            activeObject.setHeight(canvasHeight);
                            if (this.editMode) {
                                activeObject.editedSize = true;
                            }
                        } else {
                            activeObject.set({
                                width: canvasWidth,
                                height: canvasHeight
                            });
                            if (this.editMode) {
                                activeObject.editedSize = true;
                            }
                        }
                    }

                    this._alignObjecToCanvas(activeObject, 'middle');
                    this._alignObjecToCanvas(activeObject, 'center');
                    break;
                }
            }
            if (activeObject.type === 'text-transform') {
                activeObject.fire('moving', activeObject);
            }
        },
        _alignObjectInSelection: function (activeObject, align) {
            const activeObjectBound = activeObject?.getBoundingRect(true);
            const activeWidth = activeObjectBound.width;
            const activeHeight = activeObjectBound.height;
            const objects = activeObject.getObjects();
            objects?.forEach((object) => {
                switch (align) {
                    case 'left':
                        object.set({
                            left: object.originY === 'center' ? -activeWidth / 2 + object.width / 2 : -activeWidth / 2
                        });
                        break;
                    case 'right':
                        object.set({
                            left:
                                object.originY === 'center'
                                    ? activeWidth / 2 - object.width / 2
                                    : activeWidth / 2 - object.width
                        });
                        break;
                    case 'top':
                        object.set({
                            top: object.originX === 'center' ? -activeHeight / 2 + object.height / 2 : -activeHeight / 2
                        });
                        break;
                    case 'bottom':
                        object.set({
                            top:
                                object.originX === 'center'
                                    ? activeHeight / 2 - object.height / 2
                                    : activeHeight / 2 - object.height
                        });
                        break;
                    case 'center':
                        object.set({
                            top: object.originX === 'center' ? 0 : -(object.height / 2)
                        });
                        break;
                    case 'middle':
                        object.set({
                            left: object.originY === 'center' ? 0 : -(object.width / 2)
                        });
                        break;
                }
                if (object.type === 'text-transform') {
                    object.fire('moving', object);
                }
            });
        },
        /**
         * Aligns elements
         * @param {String} align Either "left", "center", "right", "top", "middle", "bottom", "fit", "fit-width", "fit-height"
         * @param {String} type Either "selection", "canvas"
         * @param {Boolean} isEditMode is edit mode
         */
        elementsSelectedAlign: function (align, type = 'selection', isEditMode = false) {
            this.editMode = isEditMode;
            const activeObject = this.getActiveObject();
            if (!activeObject) return null;

            const transform = {
                action: 'drag',
                original: fabric.util.saveObjectTransform(activeObject)
            };

            const isFitAlign = align === 'fit' || align === 'fit-width' || align === 'fit-height';

            if (isFitAlign || type !== 'selection' || activeObject.type !== 'activeSelection') {
                const objects = activeObject.getObjects?.();
                if ((objects?.length > 0 && objects.some((o) => o.group.locked)) || activeObject?.locked) return null;
                this._alignObjecToCanvas(activeObject, align);
            } else {
                transform.action = 'dragInsideSelection';
                this._alignObjectInSelection(activeObject, align);
            }

            /**
             * trigger modified event in order to
             * be catch by undo redo event listeners
             */
            activeObject.fire('modified', {
                target: activeObject,
                transform
            });
            if (activeObject.type === 'activeSelection') {
                this.fire('object:modified', {
                    target: activeObject,
                    transform
                });
            }
            return activeObject;
        }
    });
})();
